(function () {
  'use strict';

  angular
    .module('app.product.price', [])

    .directive('productPrice', function () {
      return {
        restrict: 'E',
        require: {
          productCtrl: '^^productDetail'
        },
        bindToController: {
          jsonPrice: '=',
          prices: '<',
          txtFirstRange: '@',
          txtRange: '@',
          txtLastRange: '@'
        },
        /* @ngInject */
        controller: ["LoadService", function (LoadService) {
          var ctrl = this;

          ctrl.$onInit = function () {
            ctrl.js = ctrl.productCtrl.js;
            LoadService.getService('AsyncProductService', { ctrl: ctrl }, 'initPrice');
          };
        }]
      };
    });

})();
